module.exports = __webpack_public_path__ + "img/points_transaction.80e388c9.svg";